var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfiguracionComponent',{attrs:{"variadores":_vm.variadores,"loading":_vm.loading},on:{"onInsertCabezal":_vm.handleInsertCabezal,"onUpdateCabezal":_vm.handleUpdateCabezal,"onDeleteCabezal":_vm.handleDeleteCabezal}})
}
var staticRenderFns = []

export { render, staticRenderFns }